import { FunctionComponent, useState } from 'react';
import { resetPassword } from 'pages/password-reset/actions';
import { useNavigate, useParams } from 'react-router';
import { useDispatch } from 'react-redux';
import Form from 'pages/password-reset/components/Form';
import i18n from 'i18n';
import toggleNotification from 'actions/notifications';
import Wrapper from 'pages/password-reset/components/Wrapper';
import { LockOutlined } from '@material-ui/icons';

const PasswordResetUpdate: FunctionComponent = () => {
  const [isLoading, toggleLoading] = useState(false);
  const { token } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onSave = (password: string) => {
    toggleLoading(true);
    resetPassword(password, token)
      .then(({ message }) => {
        toggleLoading(false);
        if (message === 'success') {
          dispatch(
            toggleNotification(
              i18n.t('notifications.passwordReset.success'),
              'success'
            )
          );
          navigate('/success');
        } else {
          dispatch(
            toggleNotification(
              i18n.t('notifications.passwordReset.error'),
              'error'
            )
          );
        }
      })
      .catch(() => {
        toggleLoading(false);
        dispatch(toggleNotification(i18n.t('notifications.apiError'), 'error'));
      });
  };

  return (
    <Wrapper
      icon={<LockOutlined />}
      title={i18n.t('pages.passwordReset.update.title')}
      subtitle={i18n.t('pages.passwordReset.update.subtitle')}
    >
      <Form onSave={onSave} isLoading={isLoading} />
    </Wrapper>
  );
};

export default PasswordResetUpdate;
